/* eslint-env browser */

'use strict';

const sendExperimentTrackyMessage = require('../../experiments/frontend/sendExperimentTrackyMessage');

const DealPageReady = {
  init(payload, done) {
    window.Groupon.Performance.pageReady();
    sendExperimentTrackyMessage();
    return done();
  },
};

module.exports = DealPageReady;
